import React, { useState } from 'react';
import { Table, ConfigProvider, theme, Input, Select, Button, Modal, DatePicker } from 'antd';
import { Filter, Download, Users, ChevronLeft, ChevronRight, ArrowLeft, Plus, X, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../Layout';

const { RangePicker } = DatePicker;

// Dữ liệu mẫu báo cáo đi muộn bám sát hình ảnh
const lateReportData = [
    { 
        key: '1', 
        code: 'GTV.005', 
        name: 'Đào Trọng Tín', 
        dept: '[GTV] Team Nhân Sự', 
        pos: '[GTV] Nhân viên nhân sự', 
        shift: 'GTV-HC', 
        date: '22/08/2025', 
        timeIn: '13:40:00', 
        timeOut: '13:48:00', 
        lateDuration: '4h 40p', 
        fine: '5,000' 
    },
    { 
        key: '2', 
        code: 'GTV.005', 
        name: 'Đào Trọng Tín', 
        dept: '[GTV] Team Nhân Sự', 
        pos: '[GTV] Nhân viên nhân sự', 
        shift: 'GTV-HC', 
        date: '27/08/2025', 
        timeIn: '15:31:00', 
        timeOut: '15:33:00', 
        lateDuration: '6h 31p', 
        fine: '5,000' 
    },
];

export default function BaoCaoDiMuon() {
    const navigate = useNavigate();

    // State quản lý Modal Bộ lọc và Người xem
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isViewerModalOpen, setIsViewerModalOpen] = useState(false);

    // State quản lý danh sách phân quyền người xem trong Modal
    const [viewerPermissions, setViewerPermissions] = useState([
        { id: 1, targets: ['Ban giám đốc'], permission: 'all' }
    ]);

    const handleAddPermissionRow = () => {
        setViewerPermissions([...viewerPermissions, { id: Date.now(), targets: [], permission: 'all' }]);
    };

    const handleRemovePermissionRow = (id) => {
        setViewerPermissions(viewerPermissions.filter(item => item.id !== id));
    };

    // Định nghĩa các cột cho bảng Báo cáo đi muộn
    const columns = [
        { title: 'Mã NV', dataIndex: 'code', key: 'code', width: 110, render: (t) => <span className="font-semibold text-slate-700 dark:text-slate-200">{t}</span> },
        { title: 'Họ và tên', dataIndex: 'name', key: 'name', width: 150, render: (t) => <span className="font-medium text-slate-900 dark:text-white">{t}</span> },
        { title: 'Phòng ban', dataIndex: 'dept', key: 'dept', width: 180 },
        { title: 'Vị trí', dataIndex: 'pos', key: 'pos', width: 180 },
        { title: 'Ca làm việc', dataIndex: 'shift', key: 'shift', width: 120, align: 'center' },
        { title: 'Ngày', dataIndex: 'date', key: 'date', width: 120, align: 'center' },
        { title: 'Giờ vào', dataIndex: 'timeIn', key: 'timeIn', width: 110, align: 'center', render: (t) => <span className="text-[#357f96] font-medium">{t}</span> },
        { title: 'Giờ về', dataIndex: 'timeOut', key: 'timeOut', width: 110, align: 'center' },
        { title: 'Thời gian đi muộn', dataIndex: 'lateDuration', key: 'lateDuration', width: 140, align: 'center', render: (t) => <span className="text-red-500 font-semibold">{t}</span> },
        { title: 'Phạt đi muộn', dataIndex: 'fine', key: 'fine', width: 120, align: 'right', render: (t) => <span className="font-medium text-slate-700 dark:text-slate-300">{t} đ</span> },
    ];

    return (
        <ConfigProvider theme={{ algorithm: theme.defaultAlgorithm }}>
            <div className="h-screen w-full flex overflow-hidden bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-slate-100 font-sans">
                <Layout>
                    <div className="flex flex-col flex-1">
                        
                        {/* Thanh tiêu đề trang & các nút công cụ */}
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 gap-4 shrink-0">
                            <div className="flex items-center gap-3">
                                <button 
                                    onClick={() => navigate('/timekeeping-reports')}
                                    className="p-2 rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                                    title="Quay lại"
                                >
                                    <ArrowLeft size={18} />
                                </button>
                                <div>
                                    <h1 className="text-xl font-bold tracking-tight text-slate-900 dark:text-white">Báo cáo đi muộn</h1>
                                    <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">Báo cáo đi muộn theo ngày 01/09/2026 - 17/09/2026</p>
                                </div>
                            </div>

                            {/* Các nút công cụ góc phải */}
                            <div className="flex items-center gap-2">
                                <Button 
                                    icon={<Eye size={15} />} 
                                    className="flex items-center gap-1.5 rounded-lg border-slate-300 dark:border-slate-600 dark:bg-slate-800 dark:text-white dark:!bg-[#0f172a]"
                                >
                                    Xem theo
                                </Button>
                                <Button 
                                    icon={<Filter size={15} />} 
                                    onClick={() => setIsFilterOpen(true)}
                                    className="flex items-center gap-1.5 rounded-lg border-slate-300 dark:border-slate-600 dark:bg-slate-800 dark:text-white dark:!bg-[#0f172a]"
                                >
                                    Bộ lọc
                                </Button>
                                <Button 
                                    icon={<Download size={15} />} 
                                    className="flex items-center gap-1.5 rounded-lg border-slate-300 dark:border-slate-600 dark:bg-slate-800 dark:text-white dark:!bg-[#0f172a]"
                                >
                                    Export
                                </Button>
                                <Button 
                                    icon={<Users size={15} />} 
                                    onClick={() => setIsViewerModalOpen(true)}
                                    className="flex items-center gap-1.5 rounded-lg border-slate-300 dark:border-slate-600 dark:bg-slate-800 dark:text-white dark:!bg-[#0f172a]"
                                >
                                    Người xem
                                </Button>
                            </div>
                        </div>

                        {/* Bảng dữ liệu chính */}
                        <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl shadow-sm flex flex-col flex-1 min-h-0 overflow-hidden">
                            <div className="flex-1 overflow-hidden">
                                <Table
                                    columns={columns}
                                    dataSource={lateReportData}
                                    rowKey="key"
                                    pagination={false}
                                    scroll={{ x: 1200, y: 'calc(100vh - 280px)' }}
                                    size="middle"
                                    rowSelection={{ type: 'checkbox', columnWidth: 48 }}
                                    className="custom-table"
                                />
                            </div>

                            {/* Phân trang chân bảng */}
                            <div className="flex items-center justify-between px-6 py-3 border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shrink-0">
                                <span className="text-[13px] text-slate-500 dark:text-slate-400 font-medium">Hiển thị {lateReportData.length} bản ghi</span>
                                <div className="flex gap-2">
                                    <button className="w-8 h-8 rounded border border-slate-200 dark:border-slate-700 flex items-center justify-center text-slate-400 bg-white dark:bg-slate-800">
                                        <ChevronLeft size={14} />
                                    </button>
                                    <button className="w-8 h-8 rounded border border-blue-200 dark:border-blue-800 flex items-center justify-center text-blue-700 dark:text-blue-400 font-bold bg-blue-50 dark:bg-blue-900/30">
                                        1
                                    </button>
                                    <button className="w-8 h-8 rounded border border-slate-200 dark:border-slate-700 flex items-center justify-center text-slate-400 bg-white dark:bg-slate-800">
                                        <ChevronRight size={14} />
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </Layout>

                {/* MODAL BỘ LỌC */}
                <Modal
                    title={<span className="font-semibold text-base">Bộ lọc báo cáo đi muộn</span>}
                    open={isFilterOpen}
                    onCancel={() => setIsFilterOpen(false)}
                    footer={[
                        <Button key="submit" type="primary" onClick={() => setIsFilterOpen(false)} className="bg-[#3e91ab] hover:bg-[#357f96]">
                            CẬP NHẬT
                        </Button>
                    ]}
                    className="rounded-xl overflow-hidden"
                >
                    <div className="flex flex-col gap-4 py-3">
                        <div>
                            <label className="text-xs font-semibold text-slate-500 uppercase mb-1 block">Khoảng thời gian</label>
                            <RangePicker className="w-full rounded-lg" placeholder={['Từ ngày', 'Đến ngày']} />
                        </div>
                        <div>
                            <label className="text-xs font-semibold text-slate-500 uppercase mb-1 block">Phòng ban</label>
                            <Select className="w-full" placeholder="Chọn phòng ban" allowClear>
                                <Select.Option value="ns">Team Nhân Sự</Select.Option>
                                <Select.Option value="kd">Phòng Kinh Doanh</Select.Option>
                            </Select>
                        </div>
                        <div>
                            <label className="text-xs font-semibold text-slate-500 uppercase mb-1 block">Từ khóa</label>
                            <Input placeholder="Nhập tên hoặc mã nhân viên..." className="rounded-lg" />
                        </div>
                    </div>
                </Modal>

                {/* MODAL CẬP NHẬT NGƯỜI XEM BÁO CÁO */}
                <Modal
                    title={<span className="font-semibold text-base">Cập nhật người xem báo cáo</span>}
                    open={isViewerModalOpen}
                    onCancel={() => setIsViewerModalOpen(false)}
                    width={650}
                    footer={[
                        <Button key="back" onClick={() => setIsViewerModalOpen(false)}>HỦY BỎ</Button>,
                        <Button key="submit" type="primary" onClick={() => setIsViewerModalOpen(false)} className="bg-[#357f96] hover:bg-[#357f96] border-none">
                            CẬP NHẬT
                        </Button>
                    ]}
                    className="rounded-xl overflow-hidden"
                >
                    <div className="flex flex-col gap-4 py-2">
                        <div>
                            <label className="text-xs font-semibold text-slate-400 uppercase mb-1 block">Tên báo cáo</label>
                            <Input defaultValue="Báo cáo đi muộn" disabled className="rounded-lg bg-slate-50 dark:bg-slate-800 text-slate-700 dark:text-slate-300" />
                        </div>

                        <div className="grid grid-cols-12 gap-3 items-center">
                            <div className="col-span-8 text-xs font-semibold text-slate-400 uppercase">Người xem báo cáo</div>
                            <div className="col-span-4 text-xs font-semibold text-slate-400 uppercase">Quyền xem</div>
                        </div>

                        {viewerPermissions.map((item) => (
                            <div key={item.id} className="grid grid-cols-12 gap-3 items-center">
                                <div className="col-span-8">
                                    <Select
                                        mode="multiple"
                                        placeholder="Chọn người xem hoặc phòng ban..."
                                        defaultValue={['Ban giám đốc']}
                                        className="w-full"
                                        options={[
                                            { value: 'Ban giám đốc', label: 'Ban giám đốc' },
                                            { value: 'Phòng Nhân sự', label: 'Phòng Nhân sự' },
                                            { value: 'Tất cả nhân viên', label: 'Tất cả nhân viên' },
                                        ]}
                                    />
                                </div>
                                <div className="col-span-4">
                                    <Select
                                        defaultValue="all"
                                        className="w-full"
                                        options={[
                                            { value: 'all', label: 'Tất cả' },
                                            { value: 'department', label: 'Theo phòng ban' },
                                            { value: 'personal', label: 'Cá nhân' },
                                        ]}
                                    />
                                </div>
                                <div className="col-span-1 flex justify-center">
                                    {viewerPermissions.length > 1 && (
                                        <button 
                                            onClick={() => handleRemovePermissionRow(item.id)}
                                            className="text-slate-400 hover:text-red-500 transition-colors"
                                            title="Xóa dòng"
                                        >
                                            <X size={18} />
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}

                        <div>
                            <button 
                                onClick={handleAddPermissionRow}
                                className="w-8 h-8 rounded-full bg-[#357f96] hover:bg-[#357f96] text-white flex items-center justify-center shadow-sm transition-colors mt-1"
                                title="Thêm phân quyền"
                            >
                                <Plus size={16} />
                            </button>
                        </div>
                    </div>
                </Modal>

                {/* STYLE TÙY CHỈNH BẢNG */}
                <style dangerouslySetInnerHTML={{
                    __html: `
                    .custom-table .ant-table { background: transparent !important; color: inherit; font-size: 13px; }
                    .custom-table .ant-table-thead > tr > th { 
                        background: #f8fafc !important; 
                        border-bottom: 1px solid #e2e8f0; 
                        color: #64748b; font-weight: 600; font-size: 11px; text-transform: uppercase;
                        padding: 10px 12px; white-space: normal;
                    }
                    .dark .custom-table .ant-table-thead > tr > th { 
                        background: #0f172a !important; border-bottom-color: #334155; color: #94a3b8; 
                    }
                    .custom-table .ant-table-tbody > tr > td { 
                        border-bottom: 1px solid #f1f5f9; padding: 10px 12px; transition: background 0.15s; white-space: nowrap;
                    }
                    .dark .custom-table .ant-table-tbody > tr > td { border-bottom-color: #334155; }
                    .custom-table .ant-table-tbody > tr:hover > td { background-color: #f8fafc !important; }
                    .dark .custom-table .ant-table-tbody > tr:hover > td { background-color: rgba(30, 41, 59, 0.5) !important; }
                `}} />
            </div>
        </ConfigProvider>
    );
}